import React from 'react';
import { Alert } from 'src/modules/shared/components/atoms/alert';
import { useHasPermissions } from 'src/modules/shared/hooks/auth';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';
import { IntegrationPermission } from 'src/modules/shared/types/permissions.type';
import { IntegrationCard } from '../../molecules/integrations/integration-card';
import { IntegrationBrandAvatar } from '../../molecules/integrations/integration-brand-avatar';
import { WhatsAppBillingPolicyControl } from './whatsapp-billing-policy-control';
import { WhatsAppIntegrationCardEnabled } from './whatsapp-integration-card-enabled';

/** Selects the WhatsApp onboarding card permitted for the current user. */
export const WhatsAppIntegrationCard: React.FC = () => {
  const { t } = useI18n();
  const { hasPermission: canCreateIntegration } = useHasPermissions(
    IntegrationPermission.Create
  );

  if (!canCreateIntegration) {
    return (
      <IntegrationCard
        title={t('settings.integrations.whatsapp.title')}
        subtitle={t('settings.integrations.whatsapp.description')}
        cardProps={{ shadow: 'md', variant: 'primary', appearance: 'outline' }}
        icon={<IntegrationBrandAvatar integrationId="whatsapp" />}
      >
        <div className="space-y-4">
          <Alert
            size="md"
            variant="warning"
            message={t('settings.integrations.whatsapp.warning.adminRequired')}
          />
          <WhatsAppBillingPolicyControl />
        </div>
      </IntegrationCard>
    );
  }

  return <WhatsAppIntegrationCardEnabled />;
};
